<template>
  <el-select
    @change="selectChanged"
    v-model="valueli"
    :placeholder="placeDefult==''?placeDef:placeDefult"
    clearable
    :size="size"
    :disabled="isdisabled"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="{value:item.value,label:item.label,code:item.code}"
    ></el-option>
  </el-select>
</template>
<script>
import * as pmiDictionary from '@/api/public';
export default {
  props: [
    'NamespaceId',
    'typeids',
    'createName',
    'placeDefult',
    'sindex',
    'isdisabled',
    'size',
  ],
  components: {},
  data() {
    return {
      options: [],
      valueli: { value: '', label: '', code: '' },
      placeDef: '请选择',
    };
  },

  created() {
    this.valueli.value = this.typeids;
    this.valueli.label = this.createName;
    this.getList();
  },
  methods: {
    selectChanged(val) {
      this.$emit('selectData', val, this.sindex);
    },

    getList() {
      let _this = this;
      let data = { NamespaceId: _this.NamespaceId };
      pmiDictionary.getList(data).then((response) => {
        // console.log(response);
        response.result.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          modeInfo.code = item.code; //新增的字段
          _this.options.push(modeInfo);
        });
      });
    },
  },
};
</script>
<style  scoped>
</style>
